import { render, staticRenderFns } from "./SwitchWork.vue?vue&type=template&id=37c5eae9&"
import script from "./SwitchWork.vue?vue&type=script&lang=js&"
export * from "./SwitchWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports